import React from 'react';
import {toast} from "react-toastify";

const CopyString = ({children, onClick, href, text, style}) => {
    const copyText = (e) => {
        e.stopPropagation();
        navigator.clipboard && navigator.clipboard.writeText(text || children);
        toast.success('Скопировано')
    };

    return (
        <span style={style} className={`copy-string ${onClick ? 'clickable' : ''}`} onClick={onClick ? (onClick === true ? (e)=>copyText(e) : onClick) : null} href={href}>
            {children}
            <span className='copy-string__icon' onClick={(e)=>copyText(e)}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.3541 0.583313H9.77075V4.08331H13.2708V3.49998L10.3541 0.583313Z" fill="#CCE4FF"/>
                    <path d="M8.31246 6.41663H4.81246V2.91663H0.729126V13.4166H8.31246V6.41663Z" fill="#CCE4FF"/>
                    <path d="M8.89587 6.99998V5.83331V5.59152L5.63767 2.33331H5.39587H4.22921H0.145874V14H8.89587V6.99998ZM7.48742 5.83331H5.39587V3.74177L7.48742 5.83331ZM1.31254 12.8333V3.49998H4.22921V6.99998H7.72921V12.8333H1.31254Z" fill="#135CA9"/>
                    <path d="M10.0626 11.6667V12.8333H13.8542V4.66667V3.5V3.25821L10.596 0H10.3542H9.18758H5.10425V1.16667H9.18758V4.66667H12.6876V11.6667H10.0626ZM10.3542 1.40846L12.4458 3.5H10.3542V1.40846Z" fill="#135CA9"/>
                </svg>
            </span>
        </span>
    );
};

export default CopyString;




// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/copyString.jsx